import { Button } from '@/components/ui/button';
import supremeCourtContactImage from '@/assets/supreme-court-contact.png';
import { Link } from 'react-router-dom';
import ContactForm from '@/components/ContactForm';

const HeroContact = ({ noBackground = false }: { noBackground?: boolean }) => {
  return (
    <section id="contact" className={`relative py-20 ${noBackground ? '' : 'overflow-hidden'}`}>
      {!noBackground && (
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat animate-fade-in transition-all duration-1000 ease-out transform scale-105 hover:scale-100"
          style={{ backgroundImage: `url(${supremeCourtContactImage})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary/85 via-primary/75 to-primary/90 animate-fade-in"></div>
        </div>
      )}
      
      <div className="relative z-10 container mx-auto px-4 py-20">
        <div className="max-w-6xl mx-auto opacity-0 animate-fade-in transform translate-y-8" style={{ animationDelay: '0.7s', animationFillMode: 'forwards' }}>
          <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-start">
            {/* Left side - Contact Information */}
            <div className={noBackground ? "text-foreground" : "text-white"}>
              <h1 className="font-rockwell text-2xl md:text-3xl lg:text-4xl font-semibold mb-6 md:mb-8 opacity-0 animate-fade-in" style={{ animationDelay: '0.9s', animationFillMode: 'forwards' }}>
                Contact
              </h1>
              
              <p className={`${noBackground ? 'text-muted-foreground' : 'text-white/90'} text-base md:text-lg mb-8 md:mb-12 leading-relaxed opacity-0 animate-fade-in`} style={{ animationDelay: '1.2s', animationFillMode: 'forwards' }}>
                Contact Freeman & Crown Law if you have a matter that you need to discuss.
              </p>
              
              <div className="space-y-6 md:space-y-8">
                <div>
                  <p className={`font-semibold ${noBackground ? 'text-foreground' : 'text-white'} text-lg md:text-xl mb-3 md:mb-4 opacity-0 animate-fade-in`} style={{ animationDelay: '1.5s', animationFillMode: 'forwards' }}>Freeman & Crown Law</p>
                  <a href="tel:754-293-1633" className={`${noBackground ? 'text-foreground' : 'text-white/90'} text-base md:text-lg block mb-2 opacity-0 animate-fade-in hover:underline transition-colors`} style={{ animationDelay: '1.7s', animationFillMode: 'forwards' }}>(754) 293-1633</a>
                  <p className={`${noBackground ? 'text-foreground' : 'text-white/90'} text-base md:text-lg mb-10 md:mb-8 opacity-0 animate-fade-in`} style={{ animationDelay: '1.9s', animationFillMode: 'forwards' }}>
                    <a href="mailto:ade@freemanandcrown.law" className={`${noBackground ? 'text-primary hover:text-primary/80' : 'text-white hover:text-white/80'} underline underline-offset-4 transition-colors`}>
                      ade@freemanandcrown.law
                    </a>
                  </p>
                  <p className={`${noBackground ? 'text-muted-foreground' : 'text-white/80'} text-base md:text-lg mb-2 opacity-0 animate-fade-in`} style={{ animationDelay: '2.1s', animationFillMode: 'forwards' }}>Mailing Address:</p>
                  <p className={`${noBackground ? 'text-foreground' : 'text-white/90'} text-base md:text-lg opacity-0 animate-fade-in`} style={{ animationDelay: '2.3s', animationFillMode: 'forwards' }}>c/o 1314 E Las Olas Blvd</p>
                  <p className={`${noBackground ? 'text-foreground' : 'text-white/90'} text-base md:text-lg opacity-0 animate-fade-in`} style={{ animationDelay: '2.5s', animationFillMode: 'forwards' }}>Unit #2733</p>
                  <p className={`${noBackground ? 'text-foreground' : 'text-white/90'} text-base md:text-lg opacity-0 animate-fade-in`} style={{ animationDelay: '2.7s', animationFillMode: 'forwards' }}>Fort Lauderdale, FL 33301</p>
                </div>
              </div>
            </div>

            {/* Right side - Contact Form */}
            <div className={`${noBackground ? 'bg-muted/50 border-border' : 'bg-white/10 backdrop-blur-md border-white/20'} rounded-2xl p-6 md:p-8 border shadow-2xl`}>
              <ContactForm noBackground={noBackground} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroContact;